import PageNotFound from '../shared/components/Errors/PageNotFound';
import Nav from '../shared/components/NavBar/Nav';
import { useCookies } from 'react-cookie';

export default function NotFoundPage({ waitingList }: { waitingList?: boolean }) {

    const [cookies] = useCookies(['isActive']);
    const { isActive } = cookies;

    return (
        <>
            <Nav isPublic={!isActive} />
            <PageNotFound />
        </>
    )
}